module.exports = __webpack_public_path__ + "img/temp-cover-app.c38c0ef1.jpg";